var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404Manhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 181,
    viewBox: "0 0 476 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.647 160.158C277.557 160.158 317.207 140.334 317.207 115.878C317.207 91.4233 277.557 71.5984 228.647 71.5984C179.737 71.5984 140.087 91.4233 140.087 115.878C140.087 140.334 179.737 160.158 228.647 160.158Z",
    fill: "#86A5BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.647 157.579C277.557 157.579 317.207 137.754 317.207 113.299C317.207 88.8435 277.557 69.0187 228.647 69.0187C179.737 69.0187 140.087 88.8435 140.087 113.299C140.087 137.754 179.737 157.579 228.647 157.579Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.711 90.2465C204.488 75.3391 252.804 75.3391 282.582 90.2465C296.494 97.1935 303.902 106.149 304.823 115.252C305.929 104.859 298.558 94.282 282.582 86.3216C252.804 71.4326 204.581 71.4326 174.711 86.3216C158.808 94.282 151.4 104.859 152.469 115.252C153.391 106.149 160.798 97.1935 174.711 90.2465Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.711 140.276C204.489 155.165 252.804 155.165 282.582 140.276C296.495 133.329 303.902 124.3 304.824 115.252C303.902 106.149 296.495 97.1935 282.582 90.2465C252.804 75.3391 204.581 75.3391 174.711 90.2465C160.799 97.1935 153.391 106.149 152.47 115.252C153.391 124.3 160.799 133.329 174.711 140.276Z",
    fill: "url(#paint2_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.115 176.711C310.842 176.711 347.101 158.581 347.101 136.217C347.101 113.854 310.842 95.7242 266.115 95.7242C221.387 95.7242 185.128 113.854 185.128 136.217C185.128 158.581 221.387 176.711 266.115 176.711Z",
    fill: "url(#paint3_linear)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.115 174.352C310.842 174.352 347.101 156.222 347.101 133.858C347.101 111.494 310.842 93.365 266.115 93.365C221.387 93.365 185.128 111.494 185.128 133.858C185.128 156.222 221.387 174.352 266.115 174.352Z",
    fill: "url(#paint4_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.471 165.187C299.086 165.187 326.337 151.153 326.337 133.841C326.337 116.529 299.086 102.495 265.471 102.495C231.856 102.495 204.605 116.529 204.605 133.841C204.605 151.153 231.856 165.187 265.471 165.187Z",
    fill: "#476073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.503 110.436C188.693 123.301 189.908 142.547 217.364 156.088C244.82 169.629 285.943 168.954 313.753 156.088C341.562 143.222 344.074 125.247 316.618 111.722C289.162 98.197 244.329 97.6019 216.503 110.436ZM276.74 110.21C277.28 109.294 279.285 108.763 281.24 109.036C283.195 109.31 284.358 110.291 283.752 111.224C283.145 112.156 281.19 112.687 279.235 112.414C277.28 112.14 276.201 111.224 276.74 110.21ZM231.115 153.632C230.295 153.967 229.412 154.139 228.52 154.139C227.628 154.139 226.745 153.967 225.924 153.632C224.508 152.925 224.508 151.815 225.924 151.156C226.743 150.814 227.626 150.637 228.52 150.637C229.413 150.637 230.297 150.814 231.115 151.156C232.582 151.831 232.565 152.941 231.115 153.616V153.632ZM255.723 159.695C255.183 160.612 253.161 161.143 251.206 160.869C249.251 160.596 248.105 159.631 248.644 158.698C249.183 157.766 251.206 157.235 253.161 157.508C255.116 157.782 256.262 158.747 255.723 159.679V159.695ZM218.542 140.397C219.048 141.346 217.885 142.278 215.913 142.52C213.941 142.761 211.952 142.166 211.429 141.217C210.907 140.268 212.104 139.335 214.059 139.11C216.014 138.885 218.019 139.496 218.542 140.429V140.397ZM283.145 159.116C283.667 160.049 282.488 160.998 280.532 161.223C278.577 161.448 276.555 160.869 276.049 159.937C275.544 159.004 276.707 158.039 278.695 157.862C280.684 157.685 282.639 158.168 283.145 159.116ZM218.71 128.255C218.171 129.187 216.149 129.718 214.193 129.445C212.238 129.171 211.092 128.19 211.632 127.258C212.171 126.325 214.193 125.81 216.149 126.084C218.104 126.357 219.25 127.306 218.71 128.255ZM305.999 154.549C305.181 154.891 304.297 155.067 303.404 155.067C302.51 155.067 301.627 154.891 300.808 154.549C299.393 153.858 299.409 152.748 300.808 152.072C301.629 151.738 302.512 151.566 303.404 151.566C304.296 151.566 305.179 151.738 305.999 152.072C307.466 152.78 307.449 153.89 305.999 154.549ZM231.604 117.882C230.785 118.22 229.901 118.394 229.009 118.394C228.116 118.394 227.232 118.22 226.413 117.882C224.997 117.174 225.014 116.064 226.413 115.405C227.231 115.063 228.115 114.887 229.009 114.887C229.902 114.887 230.786 115.063 231.604 115.405C233.07 116.048 233.054 117.222 231.604 117.882ZM320.831 142.632C320.292 143.549 318.269 144.08 316.314 143.806C314.359 143.533 313.213 142.552 313.753 141.635C314.292 140.718 316.314 140.172 318.27 140.445C320.225 140.718 321.371 141.78 320.831 142.632ZM256.414 109.953C256.919 110.902 255.756 111.851 253.785 112.076C251.813 112.301 249.824 111.722 249.318 110.773C248.812 109.824 249.975 108.892 251.931 108.666C253.886 108.441 255.908 109.02 256.414 109.953ZM321.017 128.641C321.539 129.589 320.359 130.522 318.404 130.747C316.449 130.973 314.427 130.394 313.921 129.461C313.415 128.528 314.578 127.579 316.55 127.354C318.522 127.129 320.511 127.708 321.017 128.641ZM306.505 118.83C305.685 119.165 304.802 119.337 303.91 119.337C303.017 119.337 302.134 119.165 301.314 118.83C299.881 118.123 299.898 117.013 301.314 116.354C302.132 116.012 303.016 115.835 303.91 115.835C304.803 115.835 305.687 116.012 306.505 116.354C307.955 117.045 307.938 118.155 306.505 118.83Z",
    fill: "#849FB4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.536 108.733C188.71 121.598 188.423 142.956 215.879 156.481C243.335 170.006 288.151 170.585 315.977 157.751C343.804 144.918 344.107 123.528 316.635 109.987C289.162 96.4459 244.363 95.883 216.536 108.733ZM276.774 108.588C277.296 107.655 279.319 107.141 281.274 107.414C283.229 107.687 284.375 108.652 283.836 109.585C283.297 110.518 281.291 111.049 279.336 110.775C277.381 110.502 276.235 109.44 276.774 108.588ZM231.149 152.01C230.331 152.352 229.447 152.528 228.553 152.528C227.66 152.528 226.776 152.352 225.958 152.01C224.525 151.318 224.542 150.209 225.958 149.533C226.778 149.199 227.661 149.026 228.553 149.026C229.446 149.026 230.329 149.199 231.149 149.533C232.598 150.128 232.582 151.238 231.149 151.897V152.01ZM255.756 158.073C255.217 159.006 253.195 159.536 251.239 159.263C249.284 158.99 248.138 158.009 248.678 157.092C249.217 156.175 251.239 155.628 253.195 155.902C255.15 156.175 256.296 157.044 255.756 157.96V158.073ZM218.576 138.774C219.081 139.707 217.901 140.656 215.946 140.881C213.991 141.106 211.986 140.527 211.463 139.594C210.941 138.662 212.137 137.697 214.092 137.472C216.047 137.246 218.019 137.777 218.576 138.726V138.774ZM283.179 157.414C283.701 158.346 282.521 159.295 280.549 159.52C278.577 159.745 276.588 159.167 276.083 158.218C275.577 157.269 276.74 156.336 278.695 156.111C280.65 155.886 282.673 156.465 283.179 157.414ZM218.744 126.552C218.205 127.485 216.182 128.015 214.227 127.742C212.272 127.468 211.126 126.487 211.665 125.555C212.205 124.622 214.227 124.107 216.182 124.381C218.137 124.654 219.283 125.619 218.744 126.552ZM306.033 152.846C305.214 153.184 304.33 153.359 303.438 153.359C302.545 153.359 301.661 153.184 300.842 152.846C299.426 152.139 299.443 151.029 300.842 150.37C301.661 150.031 302.545 149.857 303.438 149.857C304.33 149.857 305.214 150.031 306.033 150.37C307.499 151.077 307.483 152.187 306.033 152.846ZM231.638 116.179C230.817 116.513 229.934 116.686 229.042 116.686C228.15 116.686 227.267 116.513 226.447 116.179C225.031 115.471 225.048 114.361 226.447 113.702C227.265 113.36 228.149 113.184 229.042 113.184C229.936 113.184 230.819 113.36 231.638 113.702C233.188 114.394 233.087 115.503 231.638 116.179ZM320.831 140.913C320.292 141.846 318.269 142.377 316.314 142.103C314.359 141.83 313.213 140.849 313.752 139.932C314.292 139.016 316.314 138.469 318.269 138.742C320.225 139.016 321.404 139.997 320.831 140.913ZM256.447 108.25C256.953 109.199 255.773 110.148 253.818 110.373C251.863 110.598 249.857 110.019 249.335 109.07C248.812 108.122 250.043 107.189 251.964 106.98C253.886 106.771 255.925 107.317 256.447 108.25ZM321.05 126.938C321.573 127.871 320.393 128.819 318.438 129.045C316.483 129.27 314.46 128.691 313.955 127.758C313.449 126.825 314.612 125.86 316.584 125.635C318.556 125.41 320.545 125.989 321.05 126.938ZM306.539 117.112C305.72 117.453 304.837 117.63 303.943 117.63C303.05 117.63 302.166 117.453 301.348 117.112C299.915 116.42 299.932 115.31 301.348 114.635C302.168 114.3 303.051 114.128 303.943 114.128C304.835 114.128 305.718 114.3 306.539 114.635C307.988 115.343 307.971 116.452 306.539 117.112Z",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.025 133.656C298.142 125.29 284.021 118.328 266.485 118.106C248.95 117.884 234.64 124.486 234.524 132.852C234.407 141.219 248.528 148.181 266.064 148.402C283.599 148.624 297.909 142.022 298.025 133.656Z",
    fill: "#BFD4E4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.711 133.64C296.822 125.62 283.286 118.946 266.476 118.734C249.667 118.521 235.95 124.85 235.838 132.869C235.727 140.889 249.263 147.563 266.073 147.775C282.882 147.988 296.599 141.659 296.711 133.64Z",
    fill: "#F2F7F9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 115.442V88.4403L61.8299 0H99.2018V86.4836H115.246V115.442H99.2018V140.878H65.7432V115.442H0ZM68.0912 36.7849L35.2196 86.4836H68.0912V36.7849Z",
    fill: "url(#paint6_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360.155 115.64V88.592L422.091 0H459.527V86.632H475.599V115.64H459.527V141.12H426.011V115.64H360.155ZM428.363 36.848L395.435 86.632H428.363V36.848Z",
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 183.911,
    y: 94.5069,
    width: 166.842,
    height: 85.8559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.21732,
    dy: 1.21732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21732
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.72549 0 0 0 0 0.796078 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 193.649,
    y: 98.8429,
    width: 145.222,
    height: 71.2131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.912989
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.623529 0 0 0 0 0.705882 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i",
    x: 234.523,
    y: 118.101,
    width: 63.5033,
    height: 30.3071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.608659
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.623529 0 0 0 0 0.705882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 140.08,
    y1: 113.306,
    x2: 317.207,
    y2: 113.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1BACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 152.359,
    y1: 95.2034,
    x2: 304.934,
    y2: 95.2034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BCD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBD1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BBD1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5C5D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 227.412,
    y1: 79.0245,
    x2: 229.881,
    y2: 151.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7992A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#627889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 189.389,
    y1: 151.796,
    x2: 338.51,
    y2: 156.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#A0B9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E9CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 206.127,
    y1: 109.19,
    x2: 319.337,
    y2: 164.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 225.604,
    y1: 105.538,
    x2: 312.642,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 25.0985,
    y1: -37.7326,
    x2: 118.459,
    y2: 170.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 385.35,
    y1: -37.4909,
    x2: 478.711,
    y2: 170.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404Manhole);
export default __webpack_public_path__ + "static/media/error_404_manhole.796f8aecb75a782ce1194c87c13d2334.svg";
export { ForwardRef as ReactComponent };